import { ProviderTreatmentStatus } from '@/services/types/treatment-types';

export enum SimpleTreatmentStatus {
  TREATING = 'TREATING',
  COMPLETED = 'COMPLETED',
  UNKNOWN = 'UNKNOWN',
}

/**
 * Get a simplified treatment status from the full treatment status.
 * Used to make the migration to the new treatment status easier.
 * @param treatmentStatus - The full treatment status.
 * @returns The simplified treatment status.
 */
export const getSimpleTreatmentStatus = (
  treatmentStatus: ProviderTreatmentStatus,
) => {
  if (
    treatmentStatus === ProviderTreatmentStatus.TREATING ||
    treatmentStatus === ProviderTreatmentStatus.DEVIATING
  ) {
    return SimpleTreatmentStatus.TREATING;
  }

  if (treatmentStatus === ProviderTreatmentStatus.COMPLETED) {
    return SimpleTreatmentStatus.COMPLETED;
  }

  return SimpleTreatmentStatus.UNKNOWN;
};
